import { InfosupCoverSheetHemerys } from "../InfosupCover";

// Variante Hémérys du livre (maquette Figma 17685:38787) : dos sombre arrondi à
// gauche, page statique blanche dessous et couverture sombre animée aux coins
// 4px / 12px. La feuille 595×842 est mise à l'échelle exacte de chaque face
// (189/595 et 181/595) pour couvrir toute la surface.
type Props = {
  travelId: number;
  travelTitle: string;
  travelImage: { id: number; realname: string; name: string; caption: string } | null;
  dateStart: string;
  dateEnd: string;
  countries: Array<{ title: string; alias: string | null }>;
};
export const InfosupBookHemerys = (props: Props) => {
  return (
    <div className="transition-[filter] duration-300 [perspective:750px] [perspective-origin:50%_46%] group-hover/book:blur-[2.5px]">
      <div className="relative h-[265px] w-[195px]">
        <div className="absolute left-0 top-[0.5px] h-[264px] w-[10px] rounded-l-[6px] bg-[#242424] shadow-[inset_0_6px_3px_rgba(255,255,255,0.1),inset_2px_0_4px_rgba(0,0,0,0.08),inset_-2px_0_1px_2px_#000,inset_0_-4px_4px_rgba(0,0,0,0.34)]" />
        <div className="absolute right-px top-1/2 h-[256px] w-[181px] -translate-y-1/2 overflow-hidden rounded-l-[4px] rounded-r-[12px] border border-[#E8E8E8] bg-white shadow-[4px_4px_15px_rgba(0,0,0,0.12)]">
          <div className="absolute top-[6.5%] right-[4%] bottom-[4%] flex w-[30%] flex-col">
            <div className="mb-[9.5%] h-[9px] w-[78%] rounded-[2px] bg-[#D9D9D9]" />
            <div className="h-[50.5px] w-full bg-[repeating-linear-gradient(to_bottom,#E0E0E0_0,#E0E0E0_2.5px,transparent_2.5px,transparent_4px)]" />
            <div className="mt-[1.5px] h-[2.5px] w-[78%] rounded-[1px] bg-[#E0E0E0]" />
            <div className="h-[12%] shrink-0" />
            <div className="h-[3px] w-[78%] rounded-[1px] bg-[#D9D9D9]" />
            <div className="h-[12%] shrink-0" />
            <div className="h-[22.5px] w-full bg-[repeating-linear-gradient(to_bottom,#E0E0E0_0,#E0E0E0_2.5px,transparent_2.5px,transparent_4px)]" />
            <div className="mt-[1.5px] h-[2.5px] w-[78%] rounded-[1px] bg-[#E0E0E0]" />
            <div className="h-[9%] shrink-0" />
            <div className="h-[2.5px] w-full rounded-[1px] bg-[#E0E0E0]" />
            <div className="mt-[1.5px] h-[2.5px] w-[78%] rounded-[1px] bg-[#E0E0E0]" />
            <div className="absolute right-0 bottom-0 h-[3px] w-[9px] rounded-[1px] bg-[#E0E0E0]" />
          </div>
          <div className="pointer-events-none absolute inset-0 rounded-[inherit] shadow-[inset_1px_0_4px_rgba(0,0,0,0.08)]" />
        </div>
        <div className="absolute left-[6px] top-[-1px] h-[266px] w-[189px] origin-left transition-transform duration-500 [filter:drop-shadow(0_8px_9px_rgba(0,0,0,0.06))_drop-shadow(0_2px_4px_rgba(0,0,0,0.05))] motion-safe:animate-book-open group-hover/book:animate-none">
          <div className="absolute inset-0 overflow-hidden rounded-l-[4px] rounded-r-[12px] border border-white/10 bg-[#12100F] shadow-[4px_4px_16px_rgba(0,0,0,0.12)]">
            <div className="absolute left-0 top-0 origin-top-left scale-[0.3176]">
              <InfosupCoverSheetHemerys {...props} />
            </div>
            <div className="pointer-events-none absolute inset-0 rounded-[inherit] shadow-[inset_1px_0_4px_rgba(0,0,0,0.12),inset_0_-4px_4px_rgba(0,0,0,0.12),inset_0_6px_3px_rgba(255,255,255,0.1)]" />
          </div>
        </div>
      </div>
    </div>
  );
};
